import React, { useLayoutEffect, useState } from "react"
import { useLocation } from "react-router-dom"

import Printers from "./Printers"
import ShiftCashier from "./ShiftCashier"
import SettingsSidebar from "./SettingsSidebar"
import SettingTopbar from "./SettingTopbar"
import SettingsMyPosTerminals from "./SettingsMyPosTerminals"
import classes from "./index.module.scss"

const Settings = () => {
  const location = useLocation()

  const [currentTab, setCurrentTab] = useState("shiftCashier")
  const [openSettingSidebar, setOpenSettingSidebar] = useState(true)

  const setInitialTab = () => {
    if (!location.state) return

    setCurrentTab(location.state.initialTab)
  }

  useLayoutEffect(() => {
    setInitialTab()
  }, [])

  return (
    <div className={classes["container"]}>
      <SettingsSidebar
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        openSettingSidebar={openSettingSidebar}
        setOpenSettingSidebar={setOpenSettingSidebar}
      />

      <SettingTopbar
        setOpenSettingSidebar={setOpenSettingSidebar}
      />

      {
        currentTab === "myPosTerminals" &&
        <SettingsMyPosTerminals />
      }
      {
        currentTab === "printers" &&
        <Printers />
      }
      {
        currentTab === "shiftCashier" &&
        <ShiftCashier />
      }
    </div>
  )
}

export default Settings